<div mat-dialog-title style="margin:0; color: #A20000; text-align: center;">
    <span translate>
        Access Denied
    </span>
</div>

<mat-dialog-content>
    <div *ngIf="portalName && student" style="padding-top:10px; padding-right:10px; max-width:500px;" translate>
        The {{portalName}} page is not available for {{student.FirstName}} {{student.LastName}}.
        <div style="padding-top:10px;" translate>
            You have been returned to the Student Summary page.
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="portalAccessDeniedCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
        </tyl-button>
    </div>
</mat-dialog-actions>
